import type { DocumentLock } from '@ztechapps/common.contract'
import { DocumentLockKeyEnum } from '@ztechapps/common.contract'
import type { UseDocumentLockResult } from '@ztechapps/common.hook'
import { useDocumentLock } from '@ztechapps/common.hook'

export type UsePurchaseOrderDocumentLock = { value: string; initialValue?: DocumentLock }
export const usePurchaseOrderDocumentLock = ({
  value,
  initialValue,
}: UsePurchaseOrderDocumentLock): UseDocumentLockResult => {
  return useDocumentLock({
    key: DocumentLockKeyEnum.PurchaseOrder,
    value,
    initialValue,
  })
}
